
    /**
     * @description
     *  Modelo de un producto de campaña sugerido.
     *
     * @see gigot-backend/Models/Products/CampaignProduct.cs
     */

export class CampaignProductSuggested {

	public campaignProductId: number;
	public id: number;
	public priority: number;
	public suggestedId: number;

    /**
     * @description
     *	Construye un producto de campaña sugerido con una semántica vacía.
	 *	Nótese que no es lo mismo que construir un producto con valores por
	 *	defecto. Las reglas generales de construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un producto de campaña sugerido vacío.
     */
    public static empty(): CampaignProductSuggested {
        const campaignProductSuggested: CampaignProductSuggested = new CampaignProductSuggested();
		campaignProductSuggested.campaignProductId = undefined;
		campaignProductSuggested.id = undefined;
		campaignProductSuggested.priority = undefined;
		campaignProductSuggested.suggestedId = undefined;
        return campaignProductSuggested;
    }

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicCampaignProductSuggested
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
    public static from(anemicCampaignProductSuggested: CampaignProductSuggested): CampaignProductSuggested {
		if (!anemicCampaignProductSuggested) return undefined;
        const campaignProductSuggested: CampaignProductSuggested = CampaignProductSuggested.empty();
		campaignProductSuggested.campaignProductId = anemicCampaignProductSuggested.campaignProductId;
		campaignProductSuggested.id = anemicCampaignProductSuggested.id;
		campaignProductSuggested.priority = anemicCampaignProductSuggested.priority;
		campaignProductSuggested.suggestedId = anemicCampaignProductSuggested.suggestedId;
        return campaignProductSuggested;
    }
}
